import { problemWorkApi } from '../problem-work/problem-work-api'
import { notificationsApi } from '../notifications/notifications-api'
import type { Dispatch } from '@reduxjs/toolkit'

import { customAgentsApi } from '../agents/custom-agents/custom-agents-api'
import { branchesApi } from '../branches/branches-api'
import { gwbkAutogenApi } from '../dashboards/gwbk-autogen-api'
import { INGEST_TAG_TYPES, ingestApi } from '../ingest/ingest-api'
import { emitDomainTopic } from './domain-event-bus'
import type { DomainEventTopic } from './domain-events-stream'

/** Tags whose data changes when a job row or one of its children changes. */
export const INGEST_JOB_TAG_TYPES = INGEST_TAG_TYPES.filter(
  (tag) => tag.endsWith('Jobs') || tag === 'TabularConfigBuilds'
)

/** Refetch every mounted query fed by `topic`, then wake bus listeners. */
export function invalidateDomainTopic(dispatch: Dispatch, topic: DomainEventTopic): void {
  switch (topic) {
    case 'jobs':
      // The ingest transcript publishes nothing; the run that writes it also writes the job.
      dispatch(
        ingestApi.util.invalidateTags([
          ...INGEST_JOB_TAG_TYPES,
          'BranchIngestPaint',
          'IngestConversation'
        ])
      )
      dispatch(gwbkAutogenApi.util.invalidateTags(['GwbkAutogenJob']))
      break
    case 'agent-writes':
      dispatch(ingestApi.util.invalidateTags(['IngestQuestions', 'BranchIngestPaint']))
      break
    case 'tasks':
      dispatch(problemWorkApi.util.invalidateTags(['Work']))
      dispatch(notificationsApi.util.invalidateTags(['Notification', 'NotificationCounts']))
      break
    case 'runs':
      dispatch(problemWorkApi.util.invalidateTags(['OccurrenceRuns']))
      // Configs carry the unreviewed findings count that runs and reviews change.
      dispatch(
        customAgentsApi.util.invalidateTags([
          'CustomAgentRun',
          'CustomAgentConfig',
          'CustomAgentTask'
        ])
      )
      break
    case 'merges':
      // Merges and commits move branch heads, which branch reads and head drift depend on.
      dispatch(branchesApi.util.invalidateTags(['MergeRequests', 'Commits', 'Branches']))
      break
    case 'chat-queue':
      // Queued messages live in the chat slice, not RTK Query; open chats refresh off the bus.
      break
  }
  emitDomainTopic(topic)
}
